import {Component, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {MobilePopupService} from '../../services/mobile-popup/mobile-popup.service';

@Component({
    selector: 'app-component-mobile-popup',
    templateUrl: './mobile-popup.component.html',
    styleUrls: ['./mobile-popup.component.scss']
})
export class MobilePopupComponent implements OnInit {

    public open = false;

    public vars;

    private subscription: Subscription = new Subscription();

    constructor(private mobilePopup: MobilePopupService) {
        this.subscription = this.mobilePopup.open.subscribe(data => {
            this.vars = data;
            this.open = true;
        });
    }

    ngOnInit(): void {
    }

    setAnswer(key): void {
        this.mobilePopup.answer.next(key);
    }
}
